import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { SupplierSelect } from '../suppliers/SupplierSelect';
import type { WorkOrderStatus, WorkOrderPriority } from '../../types';

const statusOptions: { value: WorkOrderStatus | 'all'; label: string }[] = [
  { value: 'all', label: 'All Statuses' },
  { value: 'draft', label: 'Draft' },
  { value: 'pending', label: 'Pending' },
  { value: 'confirmed', label: 'Confirmed' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'picking', label: 'Picking' },
  { value: 'packing', label: 'Packing' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' },
];

const priorityOptions: { value: WorkOrderPriority | 'all'; label: string }[] = [
  { value: 'all', label: 'All Priorities' },
  { value: 'low', label: 'Low' },
  { value: 'normal', label: 'Normal' },
  { value: 'high', label: 'High' },
  { value: 'urgent', label: 'Urgent' },
];

interface WorkOrdersFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  status: string;
  onStatusChange: (value: string) => void;
  priority: string;
  onPriorityChange: (value: string) => void;
  supplierId?: string;
  onSupplierChange?: (supplierId: string | undefined) => void;
}

export function WorkOrdersFilters({
  search,
  onSearchChange,
  status,
  onStatusChange,
  priority,
  onPriorityChange,
  supplierId,
  onSupplierChange,
}: WorkOrdersFiltersProps) {
  return (
    <div className="flex items-center gap-3 flex-wrap">
      <Input
        placeholder="Search WO#, title, account..."
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        className="max-w-sm h-8"
      />
      <Select value={status} onValueChange={onStatusChange}>
        <SelectTrigger className="w-[150px] h-8">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          {statusOptions.map((s) => (
            <SelectItem key={s.value} value={s.value}>
              {s.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={priority} onValueChange={onPriorityChange}>
        <SelectTrigger className="w-[140px] h-8">
          <SelectValue placeholder="Priority" />
        </SelectTrigger>
        <SelectContent>
          {priorityOptions.map((p) => (
            <SelectItem key={p.value} value={p.value}>
              {p.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {onSupplierChange && (
        <div className="w-[200px]">
          <SupplierSelect
            value={supplierId}
            onSelect={(supplier) => onSupplierChange(supplier?.id)}
            placeholder="All Suppliers"
            showInactive
          />
        </div>
      )}
    </div>
  );
}
